module.exports = __webpack_public_path__ + "static/media/inboxIcon.b27a55cb.svg";